module.exports = __webpack_public_path__ + "static/WEDDING E&M-133-ffe0c59962151764efac81bd35f0a08f.jpg";